import React from "react";
import { Navigate } from "react-router-dom";
import Login from "../Components/Login/Login";
import { isTV } from "../lib/tv";

function LoginPage() {
  // Na TV, digitar email/senha no controle é sofrível. Todo caminho de login (o botão de
  // perfil, o gating reativo do RequireAuth...) cai aqui — então, na TV, mandamos para o
  // PAREAMENTO por código. No telefone/desktop, o login normal continua igual.
  if (isTV) return <Navigate to="/tv/entrar" replace />;
  return <Login />;
}

export default LoginPage;
